import ApiService from '../ApiService'

const calendarService = {

    create (data) {
      return ApiService.post('/calendar-configuration/', data)
    },

    edit (data) {
      return ApiService.post('/calendar-configuration/edit', data)
    },

    getAllowedDates (branch, city) {
      return ApiService.get(`/calendar-configuration/getAllowedDates/${branch}/${city}`)
    },

    getCalendarConfiguration (data) {
      return ApiService.post(`/calendar-configuration/getCalendarConfiguration`, data)
    }
}

export default calendarService
